import React, { useEffect } from 'react';
import { twMerge } from 'tailwind-merge';

import buttonStyles from '@/components/new-design/Button.module.css';
import styles from './TableHeaderIconButtons.module.css';
import { ReactComponent as InfoIcon } from '@/assets/icons/info-icon.svg';
import { ReactComponent as ChatIcon } from '@/assets/icons/chat-icon.svg';
import { ReactComponent as LeaveTableIcon } from '@/assets/icons/leave-table-icon.svg';
import { ReactComponent as HistoryIcon } from '@/assets/icons/refresh-icon.svg';
import ProfileConfiguration from '@/components/ProfileConfiguration/ProfileConfiguration';
import { useDispatch, useSelector } from 'react-redux';
import { ReducerState } from '@/services/common/lib/reducerState';
import useGetTableHandHistory from '@/services/table/queries/useGetTableHandHistory';
import { tableRefetchHistory } from '@/services/table/tableActions';

interface TableHeaderIconButtonsProps {
  // Add any necessary props here
  onClickShowTableInfo: () => void;
  onClickShowChat: () => void;
  onClickShowLeaveTable: () => void;
  onSettingsOpen: () => void;
  onClickHandHistory?: (() => void) | undefined;
  showChat?: boolean;
  tableId: string;
}

const TableHeaderIconButtons: React.FC<TableHeaderIconButtonsProps> = React.forwardRef<
  HTMLDivElement,
  TableHeaderIconButtonsProps
>(
  ({
    onClickShowTableInfo,
    onClickShowChat,
    onClickShowLeaveTable,
    onSettingsOpen,
    onClickHandHistory,
    showChat,
    tableId,
  }) => {
    const dispatch = useDispatch();
    // Add any necessary state or hooks here
    const modal = useSelector((state: ReducerState) => state.tables?.[tableId]?.modal);
    const { data: handHistory, refetch } = useGetTableHandHistory(tableId ?? '');
    const player = useSelector((state: ReducerState) => state.players[tableId]);

    useEffect(() => {
      if (player && player.refetchHandHistory) {
        refetch();
        dispatch(tableRefetchHistory(tableId));
      }
    }, [player?.refetchHandHistory]);
    // Add event handlers here

    return (
      <div className={twMerge(buttonStyles.pillWithBorder, styles.container)}>
        <InfoIcon
          onClick={onClickShowTableInfo}
          className={twMerge(styles.icon, modal ? '!text-ph-primary-violet hover:text-ph-primary-violet' : '')}
        />
        <div className={styles.separator} />

        <HistoryIcon
          onClick={() => handHistory && handHistory.length >= 1 && onClickHandHistory?.()}
          className={twMerge(
            styles.icon,
            styles.historyIcon,
            !(handHistory && handHistory.length >= 1) && styles.iconDisabled,
          )}
        />
        <div className={twMerge(styles.separator, styles.historyIconSeparator)} />
        <ChatIcon
          onClick={onClickShowChat}
          className={twMerge(styles.icon, showChat ? '!text-ph-primary-violet hover:text-ph-primary-violet' : '')}
        />
        <div className={styles.separator} />
        <ProfileConfiguration onSettingsOpen={onSettingsOpen} />
        <div className={styles.separator} />
        <LeaveTableIcon className={styles.icon} onClick={onClickShowLeaveTable} />
      </div>
    );
  },
);

export default TableHeaderIconButtons;
